import TableComponent from '@common/components/table';
import { Button, Card, Drawer, Modal, Popconfirm, Row, Tooltip } from 'antd';
import React, { Component } from 'react';
import GestioneLR from '../../gestioneLR/services/GestioneLR'
import queryString from 'query-string';
import FilterForm from '@common/components/filterForm';
import _ from '@common/utils/formatters/_';
import moment from 'moment';
import FileSaver from 'file-saver';
import { message } from 'antd';
import checkPermission from '@common/utils/check/permissions';


const model = (component) => {
    return {
        with_server_pagination: true,
        columns: [
            {
                title: '',
                dataIndex: '',
                sorter: false,
                key: 'actions',
                width: '60px',
                render: element => <div>{
                    !element.manuale &&
                    <Tooltip placement="top" title={"Inserisci Nuovo RL"}>
                        <Button className="m2w" size="small" shape="circle" icon={"swap"} onClick={() => component.props.history.push('/gestionelr/' + (element.id || element.id_ente) + '/inseriscilr')} />
                    </Tooltip>}
                </div>,
            },
            {
                title: 'Denominazione',
                dataIndex: '',
                sorter: true,
                key: 'denominazione',
                render: element => <div>{element.denominazione}</div>,
            },
            {
                title: 'Partita IVA',
                dataIndex: '',
                sorter: false,
                key: 'partita_iva',
                render: element => <div>{element.partita_iva}</div>,
            },
            {
                title: 'Codice fiscale Rappresentante Legale',
                dataIndex: '',
                sorter: false,
                key: 'cf',
                render: element => <div>{element.cf}</div>
            },
            {
                title: 'Cognome Rappresentante Legale',
                dataIndex: '',
                sorter: false,
                key: 'cognome',
                render: element => <div>{element.cognome}</div>,
            },
            {
                title: 'Nome Rappresentante Legale',
                dataIndex: '',
                sorter: false,
                key: 'nome',
                render: element => <div>{element.nome}</div>,
            },
            {
                title: 'Indirizzo residenza',
                dataIndex: '',
                sorter: false,
                key: 'indirizzo',
                render: element => <div>{element.indirizzo}</div>,
            },
            {
                title: 'Stato',
                dataIndex: '',
                sorter: false,
                key: 'stato',
                render: element => <div>{element.status == 10 ? 'Valido' : 'Non valido'}</div>,
            },
        ],
    }
}


const filterFormModel = (component) => {

    return {
        layout: 'vertical',
        multistep: false,
        rows: [
            {
                cols: [
                    {
                        span: 12,
                        items: [
                            {
                                type: 'string',
                                label: 'Denominazione Ente',
                                name: 'denominazione',
                            }
                        ]
                    },
                    {
                        span: 12,
                        items: [
                            {
                                type: 'string',
                                label: 'Partita IVA',
                                name: 'piva',
                            }
                        ]
                    },
                ]
            },
            {
                cols: [
                    {
                        span: 8,
                        items: [
                            {
                                type: 'string',
                                label: 'Codice fiscale Rappresentante Legale',
                                name: 'cf_lr',
                            }
                        ]
                    },
                    {
                        span: 8,
                        items: [
                            {
                                type: 'string',
                                label: 'Cognome Rappresentante Legale',
                                name: 'cognome_lr',
                            }
                        ]
                    },
                    {
                        span: 8,
                        items: [
                            {
                                type: 'string',
                                label: 'Nome Rappresentante Legale',
                                name: 'nome_lr',
                            }
                        ]
                    },
                ]
            },
            {
                cols: [
                    {
                        items: [
                            {
                                name: 'submit',
                                type: 'submit',
                                text: 'Cerca',
                                btn_type: 'primary'
                            }
                        ]
                    }
                ]
            },
        ]
    };
}

class ListEnti extends Component {

    default_order = 'id'
    base_url = '/gestionelr'

    state = {
        loading: false,
        editing_id: null,
        data: {},
    }

    componentDidMount() {
        //this.props.location.search = '?tipologia=1'
        //this.fetch(this.props.location.search)
    }

    /**
    * Se cambia la stringa aggiorna
    * @param  {[type]} newProps [description]
    * @return {[type]}          [description]
    */
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search) {
            this.fetch(this.props.location.search)
        }
    }

    refresh() {
        this.fetch(this.props.location.search)
    }

    /**
    * Chiamato da sort in tabella
    * @param  {[type]} obj [description]
    * @return {[type]}     [description]
    */
    updateQueryStr(obj) {
        _.formatSortChange(this.props, this.base_url, obj);
    }

    fetch(query) {
        let { params, pager } = _.getFilterParam(query, this.default_order);
        this.setState({ loading: true });
        GestioneLR.list(params, res => {
            let data = _.getResponse(res);
            this.setState({
                loading: false,
                data: data
            }, () => this.refs.table_component.updateTableData(
                data.data,
                parseInt(query.substring(6)),
                data.data.length,
                pager)
            );
        }, (e) => {
            this.setState({ loading: false });
        })
    }

    render() {
        return (
            <div>
                <FilterForm
                    formLayout={filterFormModel(this)}
                    base_url={this.base_url}
                    search={this.props.location.search}
                    history={this.props.history}
                    province={this.props.GlobalStore.stubs.provincia}
                />
                <Card
                    className="shadow no-pad"
                    bordered={false}
                >
                    <TableComponent
                        data={this.state.data}
                        size="medium"
                        ref="table_component"
                        loading={this.state.loading}
                        with_server_pagination={true}
                        model={model(this)}
                        updatePage={(newPage) => this.updateQueryStr({ page: newPage })}
                        updateSort={(sort, order) => this.updateQueryStr({ sort: sort })}
                    />
                </Card>
            </div>)
    }
}

export default ListEnti;